import { useTranslation } from 'react-i18next';
import { cadenceKey } from '../../utils/vinExtraction';
import { monoChipStyle, valueStyle } from './vinExtractionStyles';

const StatusCadence = ({ cron }) => {
    const { t } = useTranslation('vinExtraction');
    const key = cadenceKey(cron);

    // an unknown schedule is shown as its raw cron expression rather than under a wrong label
    return key ? (
        <span style={valueStyle}>{t(`status.cadence.${key}`)}</span>
    ) : (
        <code style={monoChipStyle}>{cron}</code>
    );
};

export default StatusCadence;
